import React, { useRef } from "react";
import { styled, alpha } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import { Button } from "@mui/material";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25)
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto"
  }
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch"
    }
  },
  "& input": {
    "&::placeholder": {
      fontSize: "10px"
    }
  }
}));

export const SearchFilterBar = ({ clearFilters, onSearch }) => {
  const searchRef = useRef(null);

  const handleSearch = () => {
    const value = searchRef.current?.value || "";
    onSearch?.(value);
  };

  const clear = () => {
    clearFilters();
    if (searchRef.current) searchRef.current.value = "";
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search suburb or postcode"
              inputProps={{ "aria-label": "search" }}
              inputRef={searchRef}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleSearch();
              }}
            />
          </Search>

          <Button variant="contained" onClick={handleSearch}>
            Search
          </Button>

          <Box sx={{ flexGrow: 1 }} />

          <Button color="error" variant="contained" onClick={clear}>
            Reset Filters
          </Button>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default SearchFilterBar;
